export function getBankIdFromUserDetails(userDetails: {
  [key: string]: any;
}): number | null {
  const bankId = Number.parseInt(userDetails?.bankId, 10);
  if (isNaN(bankId)) {
    return null;
  }
  return bankId;
}
